import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import * as Utils from "../../utils";
import { compareToSign } from "../../export/spel";
var iterateFuncs = Utils.ConfigUtils.iterateFuncs;
var logger = Utils.OtherUtils.logger;
var isFuncableProperty = function isFuncableProperty(p) {
  return ["length"].includes(p);
};
export var buildConv = function buildConv(config) {
  var operators = {};
  var _loop = function _loop(opKey) {
    var opConfig = config.operators[opKey];
    var spelOps = opConfig.spelOps ? opConfig.spelOps : opConfig.spelOp ? [opConfig.spelOp] : undefined;
    if (spelOps) {
      // examples of 2+: "==", "eq", ".contains", "matches" (can be used for starts_with, ends_with)
      spelOps.forEach(function (spelOp) {
        var opk = spelOp; // + "/" + getOpCardinality(opConfig);
        if (!operators[opk]) operators[opk] = [];
        operators[opk].push(opKey);
      });
    } else {
      logger.log("[spel] No spelOp for operator ".concat(opKey));
    }
  };
  for (var opKey in config.operators) {
    _loop(opKey);
  }
  var conjunctions = {};
  for (var conjKey in config.conjunctions) {
    var conjunctionDefinition = config.conjunctions[conjKey];
    var ck = conjunctionDefinition.spelConj || conjKey.toLowerCase();
    conjunctions[ck] = conjKey;
  }
  var funcs = {};
  var _iterator = _createForOfIteratorHelper(iterateFuncs(config)),
    _step;
  try {
    var _loop3 = function _loop3() {
      var _step$value = _slicedToArray(_step.value, 2),
        funcPath = _step$value[0],
        funcConfig = _step$value[1];
      var fks = [];
      var spelFunc = funcConfig.spelFunc;
      if (typeof spelFunc === "string") {
        var optionalArgs = Object.keys(funcConfig.args || {}).reverse().filter(function (argKey) {
          return !!funcConfig.args[argKey].isOptional || funcConfig.args[argKey].defaultValue != undefined;
        });
        var funcSignMain = spelFunc.replace(/\${(\w+)}/g, function (_, _k) {
          return "?";
        });
        var funcSignsOptional = optionalArgs.reduce(function (acc, argKey) {
          return [].concat(_toConsumableArray(acc), [[argKey].concat(_toConsumableArray(acc[acc.length - 1] || []))]);
        }, []).map(function (optionalArgKeys) {
          return spelFunc.replace(/(?:, )?\${(\w+)}/g, function (found, a) {
            return optionalArgKeys.includes(a) ? "" : found;
          }).replace(/\${(\w+)}/g, function (_, _k) {
            return "?";
          });
        });
        fks = [funcSignMain].concat(_toConsumableArray(funcSignsOptional));
      }
      var _iterator3 = _createForOfIteratorHelper(fks),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _fk = _step3.value;
          if (!funcs[_fk]) funcs[_fk] = [];
          funcs[_fk].push(funcPath);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop3();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var valueFuncs = {};
  for (var w in config.widgets) {
    var widgetDef = config.widgets[w];
    var spelImportFuncs = widgetDef.spelImportFuncs;
    if (spelImportFuncs) {
      var _iterator2 = _createForOfIteratorHelper(spelImportFuncs),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var fk = _step2.value;
          if (typeof fk === "string") {
            var fs = fk.replace(/\${(\w+)}/g, function (_, k) {
              return "?";
            });
            var argsOrder = _toConsumableArray(fk.matchAll(/\${(\w+)}/g)).map(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                _ = _ref2[0],
                k = _ref2[1];
              return k;
            });
            if (!valueFuncs[fs]) valueFuncs[fs] = [];
            valueFuncs[fs].push({
              w: w,
              argsOrder: argsOrder
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }
  var opFuncs = {};
  var _loop2 = function _loop2(op) {
    var opDef = config.operators[op];
    var spelOps = opDef.spelOps ? opDef.spelOps : opDef.spelOp ? [opDef.spelOp] : undefined;
    spelOps === null || spelOps === void 0 || spelOps.forEach(function (spelOp) {
      if (spelOp !== null && spelOp !== void 0 && spelOp.includes("${0}")) {
        var _fs = spelOp.replace(/\${(\w+)}/g, function (_, k) {
          return "?";
        });
        var _argsOrder = _toConsumableArray(spelOp.matchAll(/\${(\w+)}/g)).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            _ = _ref4[0],
            k = _ref4[1];
          return k;
        });
        if (!opFuncs[_fs]) opFuncs[_fs] = [];
        opFuncs[_fs].push({
          op: op,
          argsOrder: _argsOrder
        });
      }
    });
  };
  for (var op in config.operators) {
    _loop2(op);
  }
  // Special .compareTo()
  var compareToSS = compareToSign.replace(/\${(\w+)}/g, function (_, k) {
    return "?";
  });
  opFuncs[compareToSS] = [{
    op: "!compare",
    argsOrder: ["0", "1"]
  }];
  return {
    operators: operators,
    conjunctions: conjunctions,
    funcs: funcs,
    valueFuncs: valueFuncs,
    opFuncs: opFuncs
  };
};
export var buildFuncSignatures = function buildFuncSignatures(spel) {
  // branches
  var brns = [{
    s: "",
    params: [],
    objs: []
  }];
  _buildFuncSignatures(spel, brns);
  return brns.map(function (_ref5) {
    var s = _ref5.s,
      params = _ref5.params;
    return {
      s: s,
      params: params
    };
  }).reverse().filter(function (_ref6) {
    var s = _ref6.s;
    return s !== "" && s !== "?";
  });
};

// a.toLower().toUpper()
// ->
// ?.toLower().toUpper()
// ?.toUpper()
var _buildFuncSignatures = function _buildFuncSignatures(spel, brns) {
  var params = [],
    s = "";
  var type = spel.type,
    methodName = spel.methodName,
    val = spel.val,
    obj = spel.obj,
    args = spel.args,
    isVar = spel.isVar,
    cls = spel.cls,
    children = spel.children;
  var lastChild = children === null || children === void 0 ? void 0 : children[children.length - 1];
  var currBrn = brns[brns.length - 1];
  if (type === "!func") {
    // T(DateTimeFormat).forPattern(?).parseDateTime(?)  --  ok
    // T(LocalDateTime).parse(?, T(DateTimeFormatter).ofPattern(?))  --  will not work
    var o = obj;
    while (o) {
      var _currBrn$params;
      var _buildFuncSignatures2 = _buildFuncSignatures(_objectSpread(_objectSpread({}, o), {}, {
          obj: null
        }), [{}]),
        _buildFuncSignatures3 = _slicedToArray(_buildFuncSignatures2, 2),
        s1 = _buildFuncSignatures3[0],
        params1 = _buildFuncSignatures3[1];
      if (s1 !== "?") {
        // start new branch
        var newBrn = {
          s: currBrn.s,
          params: _toConsumableArray(currBrn.params),
          objs: _toConsumableArray(currBrn.objs)
        };
        // finish old branch
        currBrn.objs.unshift("?");
        currBrn.params.unshift(o);
        // switch
        brns.push(newBrn);
        currBrn = brns[brns.length - 1];
      }
      // step
      currBrn.objs.unshift(s1);
      (_currBrn$params = currBrn.params).unshift.apply(_currBrn$params, _toConsumableArray(params1));
      o = o.type === "!func" ? o.obj : null;
    }
    var _iterator4 = _createForOfIteratorHelper(brns),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _brn$objs;
        var brn = _step4.value;
        params = [].concat(_toConsumableArray((brn === null || brn === void 0 ? void 0 : brn.params) || []), _toConsumableArray(args || []));
        s = "";
        if (brn !== null && brn !== void 0 && (_brn$objs = brn.objs) !== null && _brn$objs !== void 0 && _brn$objs.length) s += brn.objs.join(".") + ".";
        s += (isVar ? "#" : "") + methodName;
        s += "(" + (args || []).map(function (_) {
          return "?";
        }).join(", ") + ")";
        brn.s = s;
        brn.params = params;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  } else if (type === "!new") {
    // new java.text.SimpleDateFormat('HH:mm:ss').parse('...')
    params = args || [];
    s = "new ".concat(cls.join("."), "(").concat(params.map(function (_) {
      return "?";
    }).join(", "), ")");
  } else if (type === "!type") {
    // T(java.time.LocalTime).parse('...')
    s = "T(".concat(cls.join("."), ")");
  } else if (type === "compound" && lastChild.type === "property" && isFuncableProperty(lastChild.val)) {
    // {1,2}.length  --  ok
    // 'Hello World'.bytes.length  --  will not work
    s = children.map(function (c) {
      var _params;
      if (c === lastChild) return c.val;
      var _buildFuncSignatures4 = _buildFuncSignatures(_objectSpread(_objectSpread({}, c), {}, {
          obj: null
        }), [{}]),
        _buildFuncSignatures5 = _slicedToArray(_buildFuncSignatures4, 2),
        s1 = _buildFuncSignatures5[0],
        params1 = _buildFuncSignatures5[1];
      (_params = params).push.apply(_params, _toConsumableArray(params1));
      return s1;
    }).join(".");
  } else {
    params = [spel];
    s = "?";
  }
  if (currBrn) {
    currBrn.s = s;
    currBrn.params = params;
  }
  return [s, params];
};